// This does not follow our standard pixel logic, right now I was asked to implement QUICK AND DIRTY
// Ideally we can move it to pixel logic and wrap their sdk

import axios from 'axios'
import { Cart, CartItem } from '../cart/hooks'
import { ProcessPaymentResult } from '../cart/checkout'
import { AddressInfoWrapper, ContactInfoWrapper } from '../cart/wrappers'


const getCartItemTitle = (item: CartItem) => {
  const title = item.planId?.toUpperCase()
  if (title?.indexOf('SHIPPING') !== -1) {
    return 'Shipping'
  } else if (title === 'XYO-SENTINEL-NFC-01') {
    return 'SentinelX NFC'
  } else if (title === 'XYO-SENTINEL-NFC-3-PACK-01') {
    return 'SentinelX NFC - 3 Pack'
  } else if (title === 'XYO-SENTINEL-NFC-DS-19-95') {
    return 'SentinelX NFC - Special Offer'
  } else if (title.indexOf('TRIAL') !== -1) {
    return 'COIN Trial'
  } else if (title === 'RANDOM-MINT-0-00') {
    return 'Custom Pickaxe'
  }
  return item.title
}

const getCartItemImageFromSku = (item: CartItem) => {
  let imgPath = ''
  switch (item.planId?.toUpperCase()) {
    case 'RANDOM-MINT-0-00':
      imgPath = '/free/email/RANDOM-MINT-0-00.png'
      break
    case 'XYO-SENTINEL-NFC-01':
      imgPath = '/free/email/XYO-SENTINEL-NFC-01.png'
      break
    case 'XYO-SENTINEL-NFC-3-PACK-01':
      imgPath = '/free/email/XYO-SENTINEL-NFC-3-PACK-01.png'
      break
    case 'XYO-SENTINEL-NFC-DS-19-95':
      imgPath = '/free/email/XYO-SENTINEL-NFC-3-PACK-01.png'
      break
    default:
      imgPath = '/free/email/no-image.png'
  }
  return `${window.location.protocol}//${window.location.host}${imgPath}`
}

interface IterableObj {
  pixelUrl: string
  env: string
  selectApi: (api: 'beta' | 'local' | 'prod') => void
  getApi: () => string
  getEnv: () => string
  basePayload: () => any
  identify: () => Promise<void>
  customEvent: (eventName: string) => Promise<void>
  purchaseComplete: (payment: ProcessPaymentResult) => Promise<void>
}
export const Iterable: IterableObj = {
  pixelUrl: '',
  env: 'prod',
  selectApi: (api: 'beta' | 'local' | 'prod') => {
    const apiBaseUri: Record<string, string> = {
      beta: 'https://pixel.xylabs.com',
      local: 'http://localhost:3030',
      prod: 'https://pixel.xylabs.com',
    }
    Iterable.env = api
    Iterable.pixelUrl = apiBaseUri[api] || apiBaseUri.prod
  },
  getApi: () => Iterable.pixelUrl || 'https://pixel.xylabs.com',
  getEnv: () => Iterable.env || 'prod',
  identify: async () => {
    const payload = Iterable.basePayload()
    await axios.post(`${Iterable.pixelUrl}/iterable`, {env: Iterable.getEnv(), path: '/api/users/update', payload } )
  },
  customEvent: async (eventName) => {
    const baseEvent = Iterable.basePayload()
    const payload = {...baseEvent, dataFields: { ...baseEvent.dataFields, funnelType: 'free_plus_shipping' }, eventName}
    await axios.post(`${Iterable.pixelUrl}/iterable`, { env: Iterable.getEnv(), path: '/api/events/track', payload})
  },
  purchaseComplete: async (payment) => {
    const contactData = new ContactInfoWrapper().load().data
    const addressData = new AddressInfoWrapper().load().data
    const cartData = Cart.get().data
    const cart = Cart.instance

    const sameAddress = typeof addressData.sameAddress === 'undefined' || addressData.sameAddress
    const payload = {
      user: {
        email: contactData.email,
        dataFields: {
          firstName: contactData.firstName,
          lastName: contactData.lastName,
        }
      },
      items: cartData.items?.filter(
        (item) => item && item.planId.toUpperCase().indexOf('SHIPPING') === -1
      ).map(item => ({
        id: item.planId,
        name: getCartItemTitle(item) ?? item.title,
        price: item.price,
        quantity: 1,
        imageUrl: getCartItemImageFromSku(item)
      })),
      dataFields: {
        funnelType: 'free_plus_shipping',
        billingAddressLine1: addressData.billing?.address,
        billingAddressLine2: addressData.billing?.address2,
        billingAddressCity: addressData.billing?.city,
        billingAddressState: addressData.billing?.region ,
        billingAddressCountry: addressData.billing?.country,
        billingAddressZip: addressData.billing?.postalCode,
        shippingAddressLine1: sameAddress ? addressData.billing?.address : addressData.shipping?.address,
        shippingAddressLine2: sameAddress ? addressData.billing?.address2 : addressData.shipping?.address2,
        shippingAddressCity: sameAddress ? addressData.billing?.city : addressData.shipping?.city,
        shippingAddressState: sameAddress ? addressData.billing?.region : addressData.shipping?.region,
        shippingAddressCountry: sameAddress ? addressData.billing?.country : addressData.shipping?.country,
        shippingAddressZip: sameAddress ? addressData.billing?.postalCode : addressData.shipping?.postalCode,
        orderConfirmationNumber: payment.data?.checkout?.transaction?.id,
        shippingTotal: cart.getShipping()?.price,
        subtotal: cart.getSubTotal(),
        total: cart.getTotal(),
        tax: 0
      },
      total: cartData.total
    }
    await axios.post(`${Iterable.pixelUrl}/iterable`, { env: Iterable.getEnv(), path: '/api/commerce/trackPurchase', payload })
  },
  //not clean
  basePayload: () => {
    const data = new ContactInfoWrapper().load().data
    return {
      email: data.email,
      dataFields: {
        firstName: data.firstName,
        lastName: data.lastName,
      }
    }

  }
}